import React from "react";
import { connect } from "react-redux";
import { Table, Tab } from "semantic-ui-react";
import _ from "lodash";
import ResultHeader from "./ResultHeader";
import "../../assets/styles/sub-table.css";
import { getMenuItem } from "../common/PageHelper";
import SexOffenderNimbus from "./SexOffenderNimbus";
import { getDobDate } from "../common/DisplayDate";
import Name from "./Name";

class PatriotActNimbusResult extends React.Component {
  constructor(props) {
    super(props);
    this.loadData(props);
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  loadData = (props) => {
    const results = [];
    let tabHeader;
    if (
      props.searchResultData !== undefined &&
      props.searchResultData !== null &&
      props.searchResultData !== ""
    ) {
      const crimResults = _.get(
        props.searchResultData,
        "criminals.response[0].output[0].criminals[0].criminal"
      );
      const acctType = _.get(
        this.props.searchResultData,
        `${Object.keys(this.props.searchResultData)[0]}.log[0].actType[0]`,
        ""
      );
      const showNarrowSearchMessage =
        crimResults &&
        crimResults.length > 25 &&
        (acctType.indexOf("Person") !== -1 ||
          acctType.indexOf("People") !== -1) &&
        acctType.indexOf("Enhanced") === -1;
      tabHeader = (
        <ResultHeader
          showNarrowSearchMessage={showNarrowSearchMessage}
          {...this.props}
        />
      );

      _.forEach(crimResults, (crimRes, criIndex) => {
        const dob = getDobDate(_.get(crimRes, "suspect[0].DOB[0]"), {
          userAccount: this.props.userAccount,
        });
        const name = (<Name
          node={_.get(crimRes, "suspect[0].name[0]")}
          handleNewSearchClick={this.props.handleNewSearchClick}
        />);
        const colorClass = criIndex % 2 === 0 ? "odd-row" : "even-row";
        results.push(
          <Table.Row key={`Crim_Row_${criIndex}`} className={colorClass}>
            <Table.Cell>
              <SexOffenderNimbus
                key={`Crim_Table_${criIndex}`}
                node={crimRes}
                index={criIndex}
                name={name}
                dob={dob}
                {...props}
              />
            </Table.Cell>
          </Table.Row>
        );
      });
    }
    const selectedRows = [];
    for (let index = 0; index < props.resultRecordCount; index += 1) {
      selectedRows[index] = false;
    }
    this.state = {
      selectedRows,
      results,
      tabHeader,
    };
  };

  render() {
    const tabs = [];
    const { userAccount } = this.props;
    tabs.push({
      menuItem: getMenuItem(
        userAccount.acctTheme,
        true,
        `${this.state.results.length > 0 ? this.state.results.length : 0
        } Matches Found`
      ),
      render: () => (
        <Tab.Pane>
          {this.state.tabHeader}
          {this.state.results.length > 0 && (
            <Table stackable>
              <Table.Body>{this.state.results}</Table.Body>
            </Table>
          )}
        </Tab.Pane>
      ),
    });
    return <Tab panes={tabs} />;
  }
}

function mapStateToProps(state) {
  return {
    reports: state.uiData.Reports,
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, null)(PatriotActNimbusResult);



// WEBPACK FOOTER //
// ./src/components/searchresults/PatriotActNimbusResult.js